<template>
  <div>
    <div class="aws-services-container">
      <h3 class="all-configurations-text">
        {{ this.$t('aws.allConfigurations') }}
      </h3>
      <RexButton
        id="add-new-configuration-btn"
        variant="primary"
        @onClick="handleClick"
      >
        +
        {{ $t('aws.addConfiguration') }}
      </RexButton>
    </div>
    <TableForAWS
      @handleEdit="handleEdit"
      @addConfigurationClick="handleClick"
    />
    <AwsIntegrationWindow
      v-if="showAwsIntegratiopnWindow"
      :showWindow="showAwsIntegratiopnWindow"
      :type="integrationWindowType"
      serviceName="AWS"
      :initialValue="editConfigurationInitialValue"
      @onClose="closeAwsIntegrationWindow"
    />
  </div>
</template>
<script>
import RexButton from '@/rex-components/rex-button.vue';
import TableForAWS from './aws-connections-table.vue';
import AwsIntegrationWindow from '@/components/Cloud/Settings/aws-integration-window.vue';

export default {
  name: 'AWS',
  components: {
    RexButton,
    TableForAWS,
    AwsIntegrationWindow,
  },
  methods: {
    handleClick() {
      this.showAwsIntegratiopnWindow = true;
      this.integrationWindowType = 'create';
    },
    closeAwsIntegrationWindow() {
      this.showAwsIntegratiopnWindow = false;
    },
    handleEdit(payload) {
      this.integrationWindowType = 'edit';
      this.editConfigurationInitialValue = payload;
      this.showAwsIntegratiopnWindow = true;
    },
    handleAddNewConfiguration() {
      this.showAwsIntegratiopnWindow = true;
      this.integrationWindowType = 'create';
    },
  },
  data() {
    return {
      showAwsIntegratiopnWindow: false,
      integrationWindowType: '',
      editConfigurationInitialValue: {},
    };
  },
};
</script>

<style lang="scss" scoped>
#add-new-configuration-btn {
  width: auto !important;
  padding: 1.425rem 1rem;
  display: flex;
  width: 5.5625rem;
  align-items: center;
  height: 2.1875rem;
}
.aws-services-container {
  display: flex;
  justify-content: space-between;
}
.all-configurations-text {
  color: white;
}
</style>
